(function(){
    'use strict'

    angular.module('app.calendarizaciones')
    .factory('CalendarizacionesService', CalendarizacionesService);

    CalendarizacionesService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function CalendarizacionesService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getAllAbiertas: getAllAbiertas,
            getAllCerradas: getAllCerradas,
            getAllAbiertasProcesando: getAllAbiertasProcesando,
            getById: getById,
            save: save,
            update: update,
            remove: remove
        };

        return api;

        function getAll(companiaId, tipoPlanillaId){

            var url = apiSettings.apiBaseUrl + 'api/calendarizaciones/tipo-planilla/' + companiaId + '/' + tipoPlanillaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllAbiertas(companiaId, tipoPlanillaId){

            var url = apiSettings.apiBaseUrl + 'api/calendarizaciones/tipo-planilla/abiertas/' + companiaId + '/' + tipoPlanillaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllCerradas(companiaId, tipoPlanillaId){

            var url = apiSettings.apiBaseUrl + 'api/calendarizaciones/tipo-planilla/cerradas/' + companiaId + '/' + tipoPlanillaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllAbiertasProcesando(companiaId, tipoPlanillaId){

            var url = apiSettings.apiBaseUrl + 'api/calendarizaciones/tipo-planilla/abiertas-procesando/' + companiaId + '/' + tipoPlanillaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/calendarizaciones/' + companiaId + '/' + calendarizacionId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(calendarizacion){

            if(!calendarizacion.companiaId){
                calendarizacion.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/calendarizaciones',  
                method: 'POST',  
                data: calendarizacion
            });  
            return response;
        };

        function update(calendarizacion){

            if(!calendarizacion.companiaId){
                calendarizacion.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/calendarizaciones',  
                method: 'PUT',  
                data: calendarizacion
            });  
            return response;
        };

        function remove(calendarizacion){

            if(!calendarizacion.companiaId){
                calendarizacion.companiaId = UserInfoService.getCompaniaId();
            }
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/calendarizaciones',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: calendarizacion
            });  
            return response;
        };

    };

})();